import { useContext } from 'react';
import { isNil } from 'ramda';
import { PillowTalkContext } from '../components/Chat';
export const useClientId = () => {
    const { clientId } = useContext(PillowTalkContext);
    if (isNil(clientId)) {
        throw Error('This need to be used inside the PillowTalkProvider render tree.');
    }
    return { clientId };
};
//# sourceMappingURL=useClientId.js.map